/**
 * @generated SignedSource<<a75d7b9fa41b8271e3aa9bdc70d9bf07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "participativeModuleId",
    "variableName": "participativeModuleId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsGridManagerQuery",
    "selections": [
      {
        "alias": "participativeModule",
        "args": (v4/*: any*/),
        "concreteType": "ParticipativeModule",
        "kind": "LinkedField",
        "name": "participativeModuleById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsGrid_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionsGridManagerQuery",
    "selections": [
      {
        "alias": "participativeModule",
        "args": (v4/*: any*/),
        "concreteType": "ParticipativeModule",
        "kind": "LinkedField",
        "name": "participativeModuleById",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "ContributionConnection",
            "kind": "LinkedField",
            "name": "contributions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContributionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contribution",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isFeatured",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "theme",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ThemeImages",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "preview",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipativeModule",
                        "kind": "LinkedField",
                        "name": "participativeModule",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "visualization",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bannerImageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ContributionsGrid",
                                "abstractKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Votes",
                        "kind": "LinkedField",
                        "name": "votes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "up",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCommentsCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "votesMode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "authorizations",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votesDisplayAuthorized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votesDownAuthorized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commentsDisplayAuthorized",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Votes",
                            "kind": "LinkedField",
                            "name": "votes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "down",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Reactable",
                        "abstractKey": "__isReactable"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "filters": [
              "filters"
            ],
            "handle": "connection",
            "key": "ContributionsList_contributions",
            "kind": "LinkedHandle",
            "name": "contributions"
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "themes",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ParticipativeModuleAuthorizations",
            "kind": "LinkedField",
            "name": "authorizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookmarksCreationAuthorized",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9bfb427bab6b113407217046be608dc",
    "id": null,
    "metadata": {},
    "name": "ContributionsGridManagerQuery",
    "operationKind": "query",
    "text": "query ContributionsGridManagerQuery(\n  $participativeModuleId: ID!\n  $contributionsCount: Int!\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n) {\n  participativeModule: participativeModuleById(participativeModuleId: $participativeModuleId) {\n    ...ContributionsGrid_participativeModule\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionTheme_theme on Theme {\n  name\n  primaryColor\n  primaryContrastColor\n  ...ThemeImage_theme\n}\n\nfragment ContributionsGridTiles_participativeModule on ParticipativeModule {\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters) {\n    totalCount\n    edges {\n      node {\n        id\n        ...GridContribution_contribution\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ContributionsGrid_participativeModule on ParticipativeModule {\n  slug\n  ...ContributionsGridTiles_participativeModule\n  ...ContributionsListFilters_participativeModule\n}\n\nfragment ContributionsListFilters_participativeModule on ParticipativeModule {\n  themes {\n    __typename\n    id\n  }\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n  ...ThemeFilter_participativeModule\n  ...BookmarkedFilter_participativeModule\n}\n\nfragment GridContribution_contribution on Contribution {\n  title\n  slug\n  isFeatured\n  ...ReactableMeasures_reactable\n  theme {\n    primaryColor\n    ...ContributionTheme_theme\n    id\n  }\n  participativeModule {\n    slug\n    visualization {\n      __typename\n      ... on ContributionsGrid {\n        bannerImageUrl\n      }\n      id\n    }\n    id\n  }\n  votes {\n    up\n    id\n  }\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment ThemeFilter_participativeModule on ParticipativeModule {\n  themes {\n    id\n    name\n    primaryColor\n    primaryContrastColor\n  }\n}\n\nfragment ThemeImage_theme on Theme {\n  name\n  images {\n    preview\n  }\n  primaryColor\n  primaryContrastColor\n}\n"
  }
};
})();

node.hash = "1f473580301fd71d8ea2ce23113d0b2f";

module.exports = node;
